<template>
  <div class="card quota-timeline-card shadow-sm h-100">
    <div class="card-header border-bottom py-3 px-3 d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center gap-2">
        <span class="timeline-header-icon">
          <i class="bi bi-clock-history"></i>
        </span>
        <h6 class="mb-0 fw-bold timeline-title">{{ title || 'Zaman qrafiki' }}</h6>
      </div>
    </div>
    <div class="card-body p-3 hide-scroll" style="max-height: calc(100vh - 180px); overflow-y: auto;">
      <div class="timeline timeline-one-side">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimelineList",
  props: {
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.quota-timeline-card {
  border: 1px solid var(--app-border, #e2e8f0);
  border-radius: var(--app-radius, 8px);
  background: var(--app-surface, #ffffff);
}

.timeline-header-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: rgba(11, 79, 156, 0.1);
  color: var(--bs-info, #0b4f9c);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
}

.timeline-title {
  font-size: 0.9rem;
  color: var(--app-heading, #1e293b);
}

.hide-scroll {
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

[data-theme="dark"] {
  .quota-timeline-card {
    background: #182029;
    border-color: #2e3846;
  }

  .timeline-header-icon {
    background: rgba(59, 130, 246, 0.2);
    color: #60a5fa;
  }

  .timeline-title {
    color: #f1f5f9;
  }
}
</style>
